module.exports = __webpack_public_path__ + "static/media/icetex.cfcddd84.png";